var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromptInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 3.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3621 10.1106C27.8199 9.57316 25.6581 7.43028 25.6411 7.41348C25.0842 6.86241 24.1787 6.86223 23.6231 7.41262C1.92035 28.797 11.0767 19.7751 8.75273 22.0649C8.72025 22.0932 8.67324 22.1551 8.65413 22.2095C8.54942 22.5058 6.51932 28.251 6.53309 28.212C6.46402 28.4072 6.50573 28.6154 6.63349 28.774C6.81152 28.9951 7.07234 29.0416 7.28778 28.9668C9.26738 28.282 11.6815 27.4468 13.3462 26.8709C13.3811 26.8589 13.461 26.808 13.4756 26.7936C14.1897 26.0897 9.67951 30.5353 28.3621 12.1204C28.9219 11.5654 28.9221 10.6655 28.3621 10.1106ZM21.559 10.4109L23.1998 12.0373L11.1089 23.9517C11.0727 23.9157 9.36136 22.2179 9.46892 22.3246L21.559 10.4109ZM9.15394 27.5937C9.02188 27.3351 8.85068 27.0985 8.63968 26.8891C8.42701 26.6784 8.1796 26.5027 7.91362 26.3681L9.12147 22.95C10.0501 23.8772 11.6608 25.4789 12.5987 26.4021L9.15394 27.5937ZM7.68292 27.022C8.01737 27.2089 8.30351 27.4833 8.49734 27.8209L7.24783 28.2531L7.68292 27.022ZM13.2382 26.0621L11.5974 24.4358L23.6883 12.5214C23.7245 12.5573 25.4361 14.2554 25.3286 14.1487L13.2382 26.0621ZM27.879 11.631L25.8157 13.6617C23.6984 11.5606 27.6968 15.5312 22.0507 9.92482L24.1063 7.90174C24.3957 7.6147 24.8677 7.61488 25.1571 7.90192L27.878 10.5989C28.1681 10.8859 28.1644 11.3484 27.879 11.631Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptInactive);
export default __webpack_public_path__ + "static/media/prompt-inactive.99330b996c59a6c87f474f6c734c77af.svg";
export { ForwardRef as ReactComponent };